import { render, staticRenderFns } from "./FormInfoContainer.vue?vue&type=template&id=5ebe4870&scoped=true&"
import script from "./FormInfoContainer.vue?vue&type=script&lang=js&"
export * from "./FormInfoContainer.vue?vue&type=script&lang=js&"
import style0 from "./FormInfoContainer.vue?vue&type=style&index=0&id=5ebe4870&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ebe4870",
  null
  
)

export default component.exports